import { t } from '../i18n';
import { CMS_NAMESPACE, SOCKET_PATH, type SocketAck, SocketEvents } from '@codot/contracts';
import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;
let users = 0;

/**
 * One `/cms` socket per tab, shared by every view that needs it (ref-counted). Same-origin: the HttpOnly
 * access cookie rides the handshake — no token ever touches JavaScript. Reconnects on its own after drops.
 */
export function acquireCmsSocket(): Socket {
  users++;
  socket ??= io(CMS_NAMESPACE, { path: SOCKET_PATH, transports: ['websocket'], withCredentials: true });
  return socket;
}

export function releaseCmsSocket(): void {
  users = Math.max(0, users - 1);
  if (users === 0 && socket) {
    socket.disconnect();
    socket = null;
  }
}

/** emit + ack with a timeout, typed against the contract's ack shape. */
export async function request<T extends object = SocketAck>(
  s: Socket,
  event: string,
  body: unknown,
  ms = 8_000,
): Promise<T | SocketAck> {
  try {
    return (await s.timeout(ms).emitWithAck(event, body)) as T;
  } catch {
    return { ok: false, code: 'SCREEN_OFFLINE', message: t('ui.noResponse') };
  }
}

export { SocketEvents };
